import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../components/Header';
import Footer from '../components/Footer';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const About = () => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language?.startsWith('tr') ? 'tr' : 'en';
  const [pageContent, setPageContent] = useState(null);

  useEffect(() => {
    axios.get(`${API}/api/public/content/about`).then(res => setPageContent(res.data)).catch(() => {});
  }, []);

  useEffect(() => { document.title = 'VIYERO | Hakkımızda'; return () => { document.title = 'VIYERO | Ergonomic Solutions'; }; }, []);

  const getText = (field, fallback) => {
    if (field === undefined || field === null) return fallback;
    if (typeof field === 'object') {
      const val = field[lang] !== undefined ? field[lang] : field.en;
      return val !== undefined && val !== null ? val : fallback;
    }
    return field;
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="pt-24 md:pt-32 pb-4 md:pb-6 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
            {getText(pageContent?.title, t('about.title'))}
          </h1>
          <p className="text-xl md:text-2xl text-gray-600 leading-relaxed">
            {getText(pageContent?.tagline, t('about.tagline'))}
          </p>
        </div>
      </section>

      {/* Mission Section */}
      <section className="py-[118px]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 text-center">
            {getText(pageContent?.missionTitle, t('about.missionTitle'))}
          </h2>
          <p className="text-lg text-gray-700 leading-relaxed">
            {getText(pageContent?.mission, t('about.mission'))}
          </p>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-[3px] bg-gray-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12 text-center">
            {getText(pageContent?.valuesTitle, t('about.valuesTitle'))}
          </h2>
          <div className="grid md:grid-cols-3 gap-8 md:gap-12">
            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-600 to-purple-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <div className="w-8 h-8 bg-white rounded-lg" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {getText(pageContent?.value1Title, t('about.value1Title'))}
              </h3>
              <p className="text-gray-600">
                {getText(pageContent?.value1Desc, t('about.value1Desc'))}
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-600 to-purple-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <div className="w-8 h-8 bg-white rounded-lg" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {getText(pageContent?.value2Title, t('about.value2Title'))}
              </h3>
              <p className="text-gray-600">
                {getText(pageContent?.value2Desc, t('about.value2Desc'))}
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-600 to-purple-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <div className="w-8 h-8 bg-white rounded-lg" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {getText(pageContent?.value3Title, t('about.value3Title'))}
              </h3>
              <p className="text-gray-600">
                {getText(pageContent?.value3Desc, t('about.value3Desc'))}
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default About;
